import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_StoreManagementFeeBySectionAddFeeSection = _resolveComponent("StoreManagementFeeBySectionAddFeeSection");
    const _component_List = _resolveComponent("List");
    const _component_LoadingMask = _resolveComponent("LoadingMask");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_StoreManagementFeeBySectionAddFeeSection),
        _createVNode(_component_List, {
            "is-fetching": _ctx.isFetching,
            "is-error": _ctx.isError
        }, null, 8 /* PROPS */, ["is-fetching", "is-error"]),
        _createVNode(_component_LoadingMask, {
            "is-fetching": _ctx.isFetching,
            opacity: 0,
            color: "primary",
            size: "32"
        }, null, 8 /* PROPS */, ["is-fetching"])
    ]));
}
